(function() {
  'use strict';

  const availabilityFilter = {
    name: 'filter.v.availability',
    inStockValue: '1',
    outOfStockValue: '0',
    autoCheckedAttribute: 'data-auto-in-stock-checked',
    inputSelector: 'input[name="filter.v.availability"]',
    autoInputSelector: '[data-auto-in-stock-filter]',
    formSelector: '[data-collection-filters-form]',
    updateUrlSelector: '[data-filter-update-url]',
    sortLinkSelector: '[data-sort-link]'
  };

  function hasNonAvailabilityFilter(searchParams) {
    for (const [name, value] of searchParams.entries()) {
      if (name.indexOf('filter.') === 0 && name !== availabilityFilter.name && value) {
        return true;
      }
    }

    return false;
  }

  function hasOutOfStockFilter(searchParams) {
    return searchParams.getAll(availabilityFilter.name).includes(availabilityFilter.outOfStockValue);
  }

  function updateUrlWithInStockFilter(url) {
    const filterUrl = new URL(url, window.location.origin);
    const shouldPreserveOutOfStock = hasOutOfStockFilter(filterUrl.searchParams);

    filterUrl.searchParams.delete(availabilityFilter.name);

    if (shouldPreserveOutOfStock) {
      filterUrl.searchParams.append(availabilityFilter.name, availabilityFilter.outOfStockValue);
    } else if (hasNonAvailabilityFilter(filterUrl.searchParams)) {
      filterUrl.searchParams.append(availabilityFilter.name, availabilityFilter.inStockValue);
    }

    return `${filterUrl.pathname}${filterUrl.search}${filterUrl.hash}`;
  }

  function syncFilterUpdateUrl(link) {
    const currentHref = link.getAttribute('href');

    if (!currentHref) {
      return;
    }

    link.setAttribute('href', updateUrlWithInStockFilter(currentHref));
  }

  function syncFilterUpdateUrls(root) {
    if (!root || typeof root.querySelectorAll !== 'function') {
      return;
    }

    if (typeof root.matches === 'function' && root.matches(availabilityFilter.updateUrlSelector)) {
      syncFilterUpdateUrl(root);
    }

    root.querySelectorAll(availabilityFilter.updateUrlSelector).forEach(syncFilterUpdateUrl);
  }

  function getFormSearchParams(form) {
    return new URLSearchParams(new FormData(form));
  }

  function getAutoAvailabilityInput(form) {
    let input = form.querySelector(availabilityFilter.autoInputSelector);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = availabilityFilter.name;
      input.value = availabilityFilter.inStockValue;
      input.setAttribute('data-auto-in-stock-filter', '');
      form.appendChild(input);
    }

    return input;
  }

  function removeAutomaticInStockFilter(autoInput, availabilityInputs, removeInStock) {
    if (autoInput) {
      autoInput.remove();
    }

    availabilityInputs.forEach((input) => {
      if (input.hasAttribute(availabilityFilter.autoCheckedAttribute) || removeInStock && input.value === availabilityFilter.inStockValue) {
        input.checked = false;
        input.removeAttribute(availabilityFilter.autoCheckedAttribute);
      }
    });
  }

  function syncFormInStockFilter(form) {
    if (!form) {
      return;
    }

    const formSearchParams = getFormSearchParams(form);
    const shouldPreserveOutOfStock = hasOutOfStockFilter(formSearchParams);
    const shouldApplyInStock = hasNonAvailabilityFilter(formSearchParams) && !shouldPreserveOutOfStock;
    const autoInput = form.querySelector(availabilityFilter.autoInputSelector);
    const availabilityInputs = form.querySelectorAll(`${availabilityFilter.inputSelector}:not(${availabilityFilter.autoInputSelector})`);

    if (!shouldApplyInStock) {
      removeAutomaticInStockFilter(autoInput, availabilityInputs, shouldPreserveOutOfStock);
      return;
    }

    let hasVisibleInStockInput = false;

    availabilityInputs.forEach((input) => {
      if (input.value === availabilityFilter.inStockValue) {
        hasVisibleInStockInput = true;
        input.checked = true;
        input.setAttribute(availabilityFilter.autoCheckedAttribute, '');
      } else {
        input.checked = false;
        input.removeAttribute(availabilityFilter.autoCheckedAttribute);
      }
    });

    if (!hasVisibleInStockInput) {
      getAutoAvailabilityInput(form);
    } else if (autoInput) {
      autoInput.remove();
    }
  }

  function getClosestFilterForm(target) {
    if (!target || typeof target.closest !== 'function') {
      return document.querySelector(availabilityFilter.formSelector);
    }

    const container = target.closest('[data-section-type]');
    return container ? container.querySelector(availabilityFilter.formSelector) : document.querySelector(availabilityFilter.formSelector);
  }

  function syncClosestFilterForm(target) {
    syncFormInStockFilter(getClosestFilterForm(target));
  }

  function syncCollectionHotfix(root) {
    if (!root || typeof root.querySelectorAll !== 'function') {
      return;
    }

    if (typeof root.matches === 'function' && root.matches(availabilityFilter.formSelector)) {
      syncFormInStockFilter(root);
    }

    root.querySelectorAll(availabilityFilter.formSelector).forEach(syncFormInStockFilter);
    syncFilterUpdateUrls(root);
  }

  document.addEventListener('input', (event) => {
    if (event.target && typeof event.target.closest === 'function' && event.target.closest(availabilityFilter.formSelector)) {
      syncClosestFilterForm(event.target);
    }
  }, true);

  document.addEventListener('theme:range:update', (event) => {
    syncClosestFilterForm(event.target);
  }, true);

  document.addEventListener('click', (event) => {
    if (!event.target || typeof event.target.closest !== 'function') {
      return;
    }

    const urlButton = event.target.closest(availabilityFilter.updateUrlSelector);
    const sortLink = event.target.closest(availabilityFilter.sortLinkSelector);

    if (urlButton) {
      syncFilterUpdateUrl(urlButton);
      return;
    }

    if (sortLink) {
      syncClosestFilterForm(sortLink);
    }
  }, true);

  const collectionObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          syncCollectionHotfix(node);
        }
      });
    });
  });

  syncCollectionHotfix(document);
  collectionObserver.observe(document.body, {childList: true, subtree: true});
})();
